// Design tokens BeTravel — alignés sur site betravel/css/betraveling-theme.css

export const colors = {
  // Palette principale (or)
  primary: '#D89D2F',
  primaryDark: '#B5811F',
  primaryLight: '#F5C770',
  primarySoft: '#FFF1D6',
  primaryGlow: 'rgba(216, 157, 47, 0.25)',

  // Neutres
  ink: '#1A1A1A',
  inkSoft: '#3D3D3D',
  text: '#4A4A4A',
  muted: '#8A8A8A',
  line: '#ECE4D3',
  bg: '#FFFFFF',
  bgSand: '#FFF8EC',
  bgCream: '#FAF3E2',

  // Sémantique (préservée pour les statuts)
  success: '#2e7d32',
  successDark: '#1b5e20',
  successLight: '#e8f5e9',
  error: '#e53935',
  errorLight: '#ffcccb',
  warning: '#ffc107',
  warningLight: '#fff3cd',
  info: '#0288d1',
};

export const fonts = {
  display: "'Fraunces', 'Playfair Display', Georgia, serif",
  body: "'Inter', 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
};

export const radius = {
  sm: 6,
  md: 12,
  lg: 20,
  pill: 999,
};

export const shadows = {
  sm: '0 2px 8px rgba(26, 26, 26, 0.06)',
  md: '0 8px 24px rgba(26, 26, 26, 0.08)',
  lg: '0 18px 48px rgba(26, 26, 26, 0.12)',
  gold: '0 12px 32px rgba(216, 157, 47, 0.28)',
};

export const gradients = {
  primary: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
  primaryBright: `linear-gradient(90deg, ${colors.primary}, ${colors.primaryLight})`,
  cream: `linear-gradient(180deg, ${colors.bgSand} 0%, ${colors.bgCream} 100%)`,
  ink: `linear-gradient(135deg, ${colors.ink} 0%, ${colors.inkSoft} 100%)`,
};

export const easing = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
